import React from 'react'

function renderLiteratureLink(document, idx) {
  const isPdf = true

  return (
    <a
      key={idx || 0}
      className={
        'Link u-inlineBlock' +
        (document.secureDoc === true || document.secureDoc === 'true'
          ? ' locked-content-link'
          : '')
      }
      href={document.url}
      target={isPdf ? '_blank' : ''}
      rel="noreferrer"
    >
      {document.label}
      {isPdf ? ' (PDF)' : null}
    </a>
  )
}

function getCommentary(fund) {
  let _document

  fund.documentTypes.documentType.forEach((dt) => {
    _document = dt.documents.document.find((doc) =>
      doc.fileName.includes('Commentary')
    )
  })

  return _document?.fileName
}

function renderLiterature(fund, types) {
  const documents = []

  types.forEach((t) => {
    fund.documentTypes.documentType.forEach((dt) => {
      const _document = dt.documents.document.find(
        (doc) => doc.fileName === t.name
      )

      if (_document && _document.url && _document.url.length > 0) {
        let label = t.name

        if (t.label) {
          label = t.label
        }

        _document.label = label

        documents.push(_document)
      }
    })
  })

  return (
    <>
      {documents.length > 0
        ? documents.map((document, idx) => {
            return renderLiteratureLink(document, idx)
          })
        : null}
    </>
  )
}

function lookupFundType(productType) {
  switch (productType) {
    case 'Retail':
    case 'Retail and Institutional':
      return 'Mutual Fund'
    case 'Retail ETF':
      return 'Exchange Traded Fund'
    case 'Closed End':
      return 'Closed-End Fund'
    case 'Variable Products':
      return 'Variable Product'
    default:
      return productType
  }
}

export { renderLiterature, getCommentary, renderLiteratureLink, lookupFundType }
